import { useMapEvents } from "react-leaflet";

type ZoomTrackerProps = {
  setCurrentZoom: (zoom: number) => void;
};

/**
 * Component to track map zoom level changes
 * Updates parent component state when zoom changes
 */
export function ZoomTracker({ setCurrentZoom }: ZoomTrackerProps) {
  const map = useMapEvents({
    zoomend: () => {
      setCurrentZoom(map.getZoom());
    },
  });

  return null;
}
